module.exports = __webpack_public_path__ + "static/img/200039.4eed5655.png";